import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { BuslineQueryData } from '@area-restrita/api-client/model/buslineQueryData';
import { getGetBuslinesQueryOptions } from '@area-restrita/api-client/endpoints/buslines/buslines.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import PageContainer from '@/components/layout/PageContainer';
import DataGrid from '@/components/DataGrid';
import CompanyQueryFilter from '@/components/QueryFilters/CompanyFilter';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import { Button } from '@/components/ui/button';
import { useQueryTable } from '@/hooks/useQueryTable';

import AddBuslineDialog from '../../components/AddBuslineDialog';
import { columns } from './columns';

const Buslines: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuthorization } = useAuthSessionStore();

  const canCreate = checkAuthorization(({ can }) => can('create', 'buslines'));
  const canViewDetails = checkAuthorization(({ can }) =>
    can('viewDetails', 'buslines'),
  );

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: getGetBuslinesQueryOptions,
  });

  return (
    <PageContainer title="Rotas">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        actions={
          canCreate && (
            <AddBuslineDialog>
              <Button size="sm">Adicionar Rota</Button>
            </AddBuslineDialog>
          )
        }
        toolbar={
          <div className="flex items-center space-x-2">
            <DataTableToolbar
              table={table}
              searchPlaceholder="Buscar rota..."
              searchColumnId="search"
            />
            <CompanyQueryFilter
              title="Empresa"
              column={table.getColumn('companyIds')}
            />
          </div>
        }
        onRowClick={
          canViewDetails &&
          (({ id }: BuslineQueryData) =>
            navigate({ to: '/buslines/$buslineId', params: { buslineId: id } }))
        }
      />
    </PageContainer>
  );
};

export default Buslines;
